module.exports = __webpack_public_path__ + "img/CU-ULTIMOS DPTO-2.8203fd03.jpg";